import { Component, ViewEncapsulation } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { accountsToFilterOut } from 'src/app/authentication/state/authentication.selector';
import { Register } from 'src/app/common-components/register/models/register';
import { FilterOperations } from 'src/app/filters/filter-operation/filter-operations.enum';
import { Privileges } from 'src/app/privileges/privileges';
import { getAccountPrivileges } from 'src/app/privileges/privileges.selector';
import { AccountPrivileges } from '../../account-details/models/account-privileges';
import * as ExtensionDetailActions from '../../extension-details/state/extension-detail.actions';
import { AccountOrderingOptions, AccountRegisterOptions } from '../models/account-register-options';
import { AccountRegisterListItem } from '../models/account-register-results.model';
import { AccountsFilterOption } from '../models/accounts-filter-option';
import * as AccountRegisterActions from '../state/account-register.actions';
import { accountRegisterAdapterActions } from '../state/account-register.actions';
import * as accountRegisterReducer from '../state/account-register.reducer';

@Component({
   encapsulation: ViewEncapsulation.None,
   selector: 'ndt-account-register',
   styleUrls: ['./account-register.component.scss'],
   templateUrl: './account-register.component.html',
   standalone: false,
})
export class AccountRegisterComponent extends Register<
   AccountRegisterListItem,
   AccountRegisterOptions,
   AccountOrderingOptions
> {
   entityName = 'Account';

   columns: string[] = [
      'name',
      'shortName',
      'lcsAccountNumber',
      'pstnLineLimit',
      'extensionCount',
      'phoneNumberCount',
      'logLevelId',
      'logLevelChanged',
      'accountActionsMenu',
   ];

   accountPrivileges$: Observable<AccountPrivileges>;

   constructor(public store: Store) {
      super(store, accountRegisterReducer.selectors, accountRegisterAdapterActions);
      this.accountPrivileges$ = store.pipe(select(getAccountPrivileges));
      this.store
         .select(accountsToFilterOut(Privileges.ManageAccountSettings_View))
         .pipe(
            map((accountIds: number[]) => {
               let dateTime = new Date();

               const filters: AccountsFilterOption[] = [];
               if (accountIds.length > 0) {
                  filters.push({
                     field: 'AccountId',
                     operation: FilterOperations.NotIn,
                     type: 'numeric',
                     value: accountIds,
                  });
               }

               filters.push({
                  field: 'activeEndDate',
                  operation: FilterOperations.GreaterThanOrEqualToOrNull,
                  type: 'date',
                  value: dateTime,
               });

               return filters;
            })
         )
         .subscribe((filters: AccountsFilterOption[]) => {
            this.store.dispatch(AccountRegisterActions.accountRegisterInitialFilter({ filters: filters }));
         });
   }

   onCreate(): void {
      this.store.dispatch(AccountRegisterActions.createAccount());
   }

   onResetMwi(event): void {
      this.store.dispatch(ExtensionDetailActions.resetMwi({ extensionId: undefined, accountId: undefined }));
   }

   onshowAllAccountsChanged(showAllAccountsSelected: boolean) {
      if (showAllAccountsSelected) {
         this.columns = [
            'name',
            'shortName',
            'isActive',
            'lcsAccountNumber',
            'pstnLineLimit',
            'extensionCount',
            'phoneNumberCount',
            'logLevelId',
            'accountActionsMenu',
         ];
      } else {
         this.columns = [
            'name',
            'shortName',
            'lcsAccountNumber',
            'pstnLineLimit',
            'extensionCount',
            'phoneNumberCount',
            'logLevelId',
            'accountActionsMenu',
         ];
      }
   }
}
